import React from 'react';
import PropTypes, { shape } from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import formatPrice from '../../../helpers/formatPrice';
import 'react-loading-skeleton/dist/skeleton.css';
import translatedTime from '../../../helpers/translatedTime';

const { pathname } = window.location;
const paths = pathname.split('/');
const linktype = paths[3];

function CoursesInfo({ courses, currency }) {
  return (
    courses.length === 0
      ? (
        <>
          <h6>Programa:</h6>
          <Skeleton width="50%" />
        </>
      )
      : (
        <>
          <h6>
            {
              courses.length === 1
                ? 'Programa:'
                : 'Programas:'
            }
          </h6>
          <ul>
            { courses.map(({
              name: courseName, duration, typePeriod, campusName, schoolName,
              onlyCourseWithoutSR, onlyCourse,
              onlyEnrolWithoutSR, onlyEnrol,
              onlyMaterialWithoutSR, onlyMaterial,
            }) => (
              <li key={courseName}>
                <p style={{ marginBottom: '0' }}>
                  {`Escola: ${schoolName} - ${campusName}`}
                </p>
                { `Programa: ${courseName} - ` }
                {`${duration} ${translatedTime[typePeriod]}(s)`}
                <br />
                {(linktype !== '2') && (
                <>
                  { 'Tuition: '}
                  {onlyCourseWithoutSR && onlyCourseWithoutSR > onlyCourse && (
                  <>
                    de &nbsp;
                    <span
                      className="text-decoration-line-through text-danger"
                    >
                      {`${formatPrice(onlyCourseWithoutSR, currency)}`}
                    </span>
                    &nbsp; por &nbsp;
                  </>
                  )}
                  <span className="blue">
                    {`${formatPrice(onlyCourse, currency)}`}
                    {onlyCourseWithoutSR && onlyCourseWithoutSR > onlyCourse && (
                    <>
                      &nbsp; (
                      <span
                        className="blue"
                      >
                        {`${(((onlyCourseWithoutSR - onlyCourse)
                        / onlyCourseWithoutSR) * 100).toFixed(0)}`}
                      </span>
                      %&nbsp;de desconto)
                    </>
                    )}
                  </span>
                  <br />
                  { 'Matrícula: '}
                  {onlyEnrolWithoutSR && onlyEnrolWithoutSR > onlyEnrol && (
                  <>
                    de &nbsp;
                    <span
                      className="text-decoration-line-through text-danger"
                    >
                      {`${formatPrice(onlyEnrolWithoutSR, currency)}`}
                    </span>
                    &nbsp; por &nbsp;
                  </>
                  )}
                  <span className="blue">
                    {`${formatPrice(onlyEnrol, currency)}`}
                    {onlyEnrolWithoutSR && onlyEnrolWithoutSR > onlyEnrol && (
                    <>
                      &nbsp; (
                      <span
                        className="blue"
                      >
                        {`${(((onlyEnrolWithoutSR - onlyEnrol)
                        / onlyEnrolWithoutSR) * 100).toFixed(0)}`}
                      </span>
                      %&nbsp;de desconto)
                    </>
                    )}
                  </span>
                  <br />
                  { 'Material: '}
                  {(onlyMaterialWithoutSR && (onlyMaterialWithoutSR > onlyMaterial)) && (
                  <>
                    de &nbsp;
                    <span
                      className="text-decoration-line-through text-danger"
                    >
                      1
                      {`${formatPrice(onlyMaterialWithoutSR, currency)}`}
                    </span>
                    &nbsp; por &nbsp;
                  </>
                  )}
                  <span className="blue">
                    {`${formatPrice(onlyMaterial, currency)}`}
                  </span>
                </>
                )}
              </li>
            )) }
          </ul>
        </>
      )
  );
}

CoursesInfo.propTypes = {
  courses: PropTypes.arrayOf(
    shape({
      name: PropTypes.string,
      duration: PropTypes.number,
      typePeriod: PropTypes.string,
      payment: shape({
        currency: PropTypes.string,
        value: PropTypes.number,
      }),
      image: PropTypes.string,
    }),
  ).isRequired,
  currency: PropTypes.string.isRequired,
};

export default CoursesInfo;
